<template>
  <Link :href="to">
    <slot></slot>
  </Link> 
</template>

<script>
import { Link } from '@inertiajs/vue3'

export default {
  components: {
    Link
  },
  props: {
    to: String,
  },
}
</script>
